import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  requireAdmin?: boolean;
  requireOwner?: boolean;
  requireSalesReports?: boolean;
}

export default function ProtectedRoute({
  children,
  requireAuth = true,
  requireAdmin = false,
  requireOwner = false,
  requireSalesReports = false,
}: ProtectedRouteProps) {
  const { isLoading, isAuthenticated, isAdmin, isOwner, canViewSalesReports, isManager, isKitchen } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        <span className="ml-3 text-gray-600">Cargando...</span>
      </div>
    );
  }

  // Verificar si requiere autenticación
  if (requireAuth && !isAuthenticated) {
    console.log('🔒 Redirigiendo a login - No autenticado');
    return <Navigate to="/login" replace />;
  }

  // Verificar si requiere permisos de admin
  if (requireAdmin && !isAdmin() && !isOwner() && !isManager() && !isKitchen()) {
    console.log('🔒 Redirigiendo a home - Sin permisos de admin', isKitchen());
    return <Navigate to="/" replace />;
  }

  // Verificar si requiere ser propietario
  if (requireOwner && !isOwner()) {
    console.log('🔒 Redirigiendo a admin - No es propietario');
    return <Navigate to="/admin" replace />;
  }

  // Verificar si requiere permisos de reportes de ventas
  if (requireSalesReports && !canViewSalesReports()) {
    console.log('🔒 Redirigiendo a admin - Sin permisos de reportes');
    return <Navigate to="/admin" replace />;
  }

  // Si pasa todas las verificaciones, renderizar el contenido
  return <>{children}</>;
} 